import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputGroup from "react-bootstrap/InputGroup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IconButton, Link, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  getPartnerFile,
  deletePartnerFile,
  uploadPartnerFile,
  updatePartner,
} from "../../API/endpoints/Partner";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { getRequestedInformation } from "../../API/endpoints/Email";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";

interface Document {
  id: string;
  file_name: string;
  path: string;
  description: string;
  services: any;
}

export default function PartnerUploadFiles(props: any) {
  const { setIsOpen, isOpen = false, consultantID } = props;
  const [requestedDocuments, setRequestedDocuments] = useState<any[]>([]);
  const [files, setFiles] = useState<any[]>([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      file: null,
      file_link: "",
    },
  });

  const handleClickOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const getRequestedDocuementsDetails = () => {
    (async () => {
      try {
        const response = await getRequestedInformation(
          isOpen,
          props?.consultantID
        );
        if (response.data) {
          setRequestedDocuments(
            response.data.filter((item: any) => item?.status === "REQUESTED")
          );
        }
      } catch (error) {}
    })();
  };

  useEffect(() => {
    getRequestedDocuementsDetails();
  }, [isOpen]);

  const onSubmit = (data: any) => {
    if (files.length > 0) {
      try {
        files.forEach(async (item: any) => {
          const frmData = new FormData();
          item?.url
            ? frmData.append("url", item?.url)
            : frmData.append("file", item?.file);
          frmData.append("file_name", item?.file_name);
          if (item?.description) {
            frmData.append("description", item?.description);
          }

          frmData.append("partner_id", item?.partner_id);
          frmData.append("consultant_id", consultantID);
          frmData.append("service", "1");
          const upload = await uploadPartnerFile(frmData);
        });
        const reqData = {
          status: "INFORMATION_SUBMITTED",
        };

        updatePartner(reqData, isOpen)
          .then((res) => {
            handleClose();
            props.onSuccess();
          })
          .catch((err) => {
            console.log("err", err);
          });
      } catch (err) {}
    }
  };

  const onChangeFile = (
    file: any,
    fileName: string,
    description: string,
    partnerID: string
  ) => {
    const list = [...files];
    const index = list.findIndex((f: any) => f?.file_name === fileName);
    if (index > -1) {
      list[index] = {
        file: file.length > 0 ? file[0] : null,
        file_name: fileName,
        description: description,
        partner_id: partnerID,
        url: "",
      };
    } else {
      list.push({
        file: file.length > 0 ? file[0] : null,
        file_name: fileName,
        partner_id: partnerID,
        description: description,
        url: "",
      });
    }

    setFiles([...list]);
  };

  const onChangeUrl = (
    url: string,
    fileName: string,
    description: string,
    partnerID: string
  ) => {
    const list = [...files];
    const index = list.findIndex((f: any) => f?.file_name === fileName);
    if (url.length > 0) {
      if (index > -1) {
        list[index] = {
          file: list[index].file ? list[index].file : undefined,
          file_name: fileName,
          description: description,
          partner_id: partnerID,
          url: url,
        };
      } else {
        list.push({
          file: undefined,
          file_name: fileName,
          description: description,
          partner_id: partnerID,
          url: url,
        });
      }

      setFiles([...list]);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        className="modal_867"
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Form
          onSubmit={handleSubmit((data) => {
            onSubmit(data);
          })}
          className="mt40px"
        >
          <DialogTitle id="alert-dialog-title">Upload Documents</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Document Name</TableCell>
                    <TableCell align="left">Description</TableCell>
                    {/* <TableCell align="left">File</TableCell> */}
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {requestedDocuments &&
                    requestedDocuments.map((row) => (
                      <TableRow
                        key={row?.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ width: "20%" }}
                        >
                          {row?.file_name}
                        </TableCell>
                        <TableCell sx={{ width: "20%" }} align="left">
                          {row?.description || "NA"}
                        </TableCell>
                        {/* <TableCell align="right" sx={{ width: "15%" }}>
                        <div
                          style={{
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                          }}
                        >
                          <Stack
                            style={{
                              background: "#F2F4F7",
                              width: "2rem",
                              padding: "4px",
                              textAlign: "center",
                              alignItems: "center",
                            }}
                          >
                            <img
                              width="20px"
                              src="../svgs/file-pic.svg"
                              alt="delete"
                            />
                          </Stack>
                          <a
                            className="document_dwld"
                            href={row?.path ? `${row.path}` : ""}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {row.file_name}
                          </a>
                        </div>
                      </TableCell> */}
                        <TableCell sx={{ width: "60%" }}>
                          <Row style={{ alignItems: "center" }}>
                            <Col md="auto">
                              <TextField
                                placeholder="Paste URL"
                                className="pasteurl"
                                id="outlined-end-adornment"
                                sx={{ m: 1, width: "20ch" }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <img
                                        width="20px"
                                        src="../svgs/pasteurl.svg"
                                        alt="delete"
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                // {...register("file_link")}
                                onChange={(e: any) =>
                                  onChangeUrl(
                                    e.target.value,
                                    row?.file_name,
                                    row?.description,
                                    row?.partner_id
                                  )
                                }
                              />
                            </Col>
                            <Col>
                              <Input
                                className="inputfile"
                                type="file"
                                id="input-with-icon-adornment"
                                placeholder="Upload file"
                                startAdornment={
                                  <InputAdornment position="start">
                                    <img
                                      src="../svgs/upload_icon.svg"
                                      alt="upload_icon"
                                    />
                                  </InputAdornment>
                                }
                                // {...register("file")}
                                onChange={(e: any) =>
                                  onChangeFile(
                                    e.target.files,
                                    row?.file_name,
                                    row?.description,
                                    row?.partner_id
                                  )
                                }
                              />
                            </Col>
                          </Row>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>cancel</Button>
            <Button className="btn btn-primary white" type="submit" autoFocus>
              Save
            </Button>
          </DialogActions>
        </Form>
      </Dialog>
    </React.Fragment>
  );
}
